import {useNavigation} from "@react-navigation/native";
import React, {useEffect} from "react";
import {View, Text, StyleSheet, TouchableOpacity} from "react-native";
import {useDispatch} from "react-redux";
import {globalFontStyle, globalStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";

import {showLoader} from "../../../commonComponents/Loader/loader.actions";
import {formatPL, isMobile} from "../../../utils/commonMethods";
import {useContestProbe} from "./useContestProbe";
import {GlobalScreens} from "../../../utils/globalConstant";

const ContestPortfolioLiveCard = ({item, onSellCancelClick, contestId}) => {
  const navigation = useNavigation();
  let contestDetail = useContestProbe(item);
  const probe = contestDetail?.probes;
  const dispatch = useDispatch();
  let summary = probe?.summary;
  let calls = probe?.calls;
  let liquidity = probe?.liquidity;

  const matched_yes_contracts = probe?.total_matched_contract_yes
    ? probe?.total_matched_contract_yes
    : 0;
  const matched_no_contracts = probe?.total_matched_contract_no
    ? probe?.total_matched_contract_no
    : 0;
  const matched_contracts = matched_yes_contracts + matched_no_contracts;
  const avg_price_matched_yes_contracts = probe?.avg_price_matched_contract_yes
    ? probe?.avg_price_matched_contract_yes
    : 0;
  const avg_price_matched_no_contracts = probe?.avg_price_matched_contract_no
    ? probe?.avg_price_matched_contract_no
    : 0;
  // const profitLoss =
  //   summary && summary[2].value !== "- " ? parseFloat(summary[2].value) : "- ";
  const isCDAEvent = probe?.is_price_editable ? true : false;

  const totalPendingOrder = calls.map(call => {
    return call.rank === -1;
  });
  let isPendingOrder = false;
  totalPendingOrder.includes(true)
    ? (isPendingOrder = true)
    : (isPendingOrder = false);

  let newSellPriceYes = probe?.newSellPriceYes;

  let newSellPriceNo = probe?.newSellPriceNo;

  newSellPriceNo = newSellPriceNo
    ? parseFloat(newSellPriceNo).toFixed(2)
    : null;
  newSellPriceYes = newSellPriceYes
    ? parseFloat(newSellPriceYes).toFixed(2)
    : null;

  const PendingRow = ({call}) => {
    return (
      <View
        style={{
          //flexDirection: 'row',
          //justifyContent: 'space-between',
          marginTop: 10,
          paddingTop: 15,
          paddingHorizontal: 15,
        }}>
        <View>
          <View
            key={call?.orderid}
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: 15,
            }}>
            <View style={{flexDirection: "row", flex: 1}}>
              <View style={[styles.rowCol, {alignItems: "flex-start"}]}>
                <Text style={styles.marginRow}>Shares</Text>
                <Text>
                  {call?.noofcontracts?.toFixed(2)}(
                  {call.callvalue === "Y" ? "Yes" : "No"})
                </Text>
              </View>
              <View style={[styles.rowCol, {alignItems: "flex-start"}]}>
                <Text style={styles.marginRow}>You Put</Text>
                <Text style={{textAlign: "center"}}>
                  {(call?.coins * call?.noofcontracts)?.toFixed(2)}
                </Text>
              </View>

              <View style={[styles.rowCol, {alignItems: "flex-start"}]}>
                <Text style={styles.marginRow}>You Get</Text>
                <Text> {(100 * call?.noofcontracts)?.toFixed(2)}</Text>
              </View>
              <View style={[styles.rowCol]}>
                <Text style={styles.marginRow}>Status</Text>
                <Text> Pending</Text>
              </View>
            </View>
          </View>
          <View style={isMobile() ? {} : styles.btnSellWeb}>
            <TouchableOpacity
              onPress={() => {
                onSellCancelClick({probe, isCancel: true, call});
              }}
              activeOpacity={0.8}>
              <Text
                style={[
                  styles.sellTxt,
                  styles.cancelTxt,
                  {
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                    borderColor: "#000000",
                  },
                ]}>
                Cancel
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  };

  const MatchedContract = ({isYes}) => {
    return (
      <View
        style={{
          //flexDirection: "row",
          paddingTop: 15,
          paddingHorizontal: 15,
        }}>
        <View style={{flexDirection: "row", flex: 1, marginBottom: 15}}>
          <View style={[styles.rowCol, {alignItems: "flex-start"}]}>
            <Text style={styles.marginRow}>Shares</Text>
            <Text>
              {isYes
                ? `${matched_yes_contracts.toFixed(2)} (Yes)`
                : `${matched_no_contracts.toFixed(2)} (No)`}
            </Text>
          </View>
          <View style={[styles.rowCol, {alignItems: "flex-start"}]}>
            <Text style={styles.marginRow}>You Put</Text>
            <Text>
              {isYes
                ? `${(
                    avg_price_matched_yes_contracts * matched_yes_contracts
                  ).toFixed(2)} `
                : `${(
                    avg_price_matched_no_contracts * matched_no_contracts
                  ).toFixed(2)}`}
            </Text>
          </View>
          <View style={[styles.rowCol, {alignItems: "flex-start"}]}>
            <Text style={styles.marginRow}>You Get</Text>
            <Text>
              {isYes
                ? `${(matched_yes_contracts * 100).toFixed(2)}`
                : `${(matched_no_contracts * 100).toFixed(2)}`}
            </Text>
          </View>
          <View style={[styles.rowCol]}>
            <Text style={styles.marginRow}>Status</Text>
            <Text>Matched</Text>
          </View>
        </View>

        {probe?.disablesell ? null : (
          <View style={isMobile() ? {} : styles.btnSellWeb}>
            <TouchableOpacity
              onPress={() => {
                onSellCancelClick({probe, isYes});
              }}
              activeOpacity={0.8}>
              <Text
                style={[
                  styles.sellTxt,
                  styles.cancelTxt,
                  {
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                    borderColor: "#000000",
                  },
                ]}>
                Sell(
                <Text style={{...globalFontStyle.appFontSmallText}}>
                  Current Value:{" "}
                </Text>
                <Text style={{color: Colors.tradexBlue}}>
                  {isYes
                    ? newSellPriceYes
                      ? (newSellPriceYes * matched_yes_contracts)?.toFixed(2)
                      : "-"
                    : newSellPriceNo
                    ? (+newSellPriceNo * matched_no_contracts)?.toFixed(2)
                    : "-"}
                </Text>
                )
              </Text>
            </TouchableOpacity>
          </View>
        )}
      </View>
    );
  };

  const onPortfolioTitlecClick = () => {
    dispatch(showLoader());
    if (contestId) {
      navigation.navigate("ContestEvents", {
        contestId: contestId,
        eventId: probe?.id,
        isMulti: probe?.parent_id === -1 ? true : false,
        probeInfo: probe,
      });
    }

    //navigation.navigate("Event", { eventData: probe, probeInfo: probe });
  };

  const getPL = (isYesContract, isNoContract, callData) => {
    if (callData) {
      return 0;
    }
    const youPut = isYesContract
      ? (avg_price_matched_yes_contracts * matched_yes_contracts).toFixed(2)
      : (avg_price_matched_no_contracts * matched_no_contracts).toFixed(2);
    const currentTotalSellAmount = isYesContract
      ? newSellPriceYes
        ? (newSellPriceYes * matched_yes_contracts)?.toFixed(2)
        : "-"
      : newSellPriceNo
      ? (newSellPriceNo * matched_no_contracts)?.toFixed(2)
      : "-";

    if (currentTotalSellAmount && currentTotalSellAmount !== "-") {
      return (((currentTotalSellAmount - youPut) / youPut) * 100).toFixed(2);
    } else {
      return 0;
    }
  };

  const CardRender = ({callData, isYesContract, isNoContract}) => {
    const pnL = getPL(isYesContract, isNoContract, callData);
    return (
      <View style={[globalStyle.cardContainer, {paddingHorizontal: 0}]}>
        <View style={{paddingHorizontal: 15}}>
          <TouchableOpacity
            style={styles.upperRow}
            onPress={onPortfolioTitlecClick}>
            <View style={{flexDirection: "row", alignItems: "center"}}>
              <Text
                style={[
                  globalFontStyle.appFontSubHeading,
                  {color: Colors.black, flexWrap: "wrap", flex: 1},
                ]}
                numberOfLines={3}>
                {probe?.title}
              </Text>
              <Text
                style={[
                  {color: Colors.grey},
                  pnL === 0
                    ? null
                    : pnL >= 0
                    ? {color: Colors.green}
                    : {color: Colors.red},
                ]}>
                P&L {formatPL(pnL)}
              </Text>
            </View>
            {(probe?.alternate_title || probe?.subtitle) && (
              <Text
                style={[
                  globalFontStyle.appFontBody,
                  {color: Colors.lightgrey, marginTop: 3},
                ]}
                numberOfLines={1}>
                {probe?.alternate_title
                  ? probe?.alternate_title
                  : probe?.subtitle}
              </Text>
            )}
          </TouchableOpacity>
        </View>

        <View
          style={{
            marginTop: 15,
            flex: 1,
            borderTopWidth: 0.75,
            borderTopColor: Colors.borderColor,
          }}
        />

        {isYesContract ? <MatchedContract isYes={true} /> : null}
        {isNoContract ? <MatchedContract isYes={false} /> : null}
        {callData ? <PendingRow call={callData} /> : null}
      </View>
    );
  };

  return (
    <View>
      {matched_yes_contracts ? <CardRender isYesContract={true} /> : null}
      {matched_no_contracts ? <CardRender isNoContract={true} /> : null}
      {isCDAEvent &&
        isPendingOrder &&
        calls.map((call, index) => {
          if (call.rank === -1) {
            return <CardRender callData={call} key={index} />;
          }
        })}
    </View>
  );
};

export default React.memo(ContestPortfolioLiveCard);

const styles = StyleSheet.create({
  cardImg: {
    width: 60,
    height: 60,
    marginRight: 15,
  },
  upperRow: {},
  priceBlock: {
    flexDirection: "row",
    backgroundColor: Colors.grey3,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 100,
    justifyContent: "space-between",
    borderWidth: 0.2,
    marginTop: 20,
    marginBottom: 30,
  },
  rowCol: {
    flex: 1,
    flexBasis: 0,
    flexShrink: 0,
    alignItems: "center",
  },
  rowCol1: {
    flex: 1,
    flexBasis: 0,
    flexShrink: 0,
    alignItems: "flex-end",
  },
  sellTxt: {
    borderWidth: 0.5,
    paddingHorizontal: 15,
    paddingVertical: 5,
    borderRadius: 5,
    overflow: "hidden",
    backgroundColor: "rgba(202, 44, 146, 0.1)",
    borderColor: "#CA2C92",
  },
  cancelTxt: {
    paddingHorizontal: 10,
    paddingVertical: 9,
    textAlign: "center",
    ...globalFontStyle.appFontSmallTextBold,
  },
  marginRow: {
    marginBottom: 5,
  },
  profitLossBlock: {
    paddingHorizontal: 20,
    paddingVertical: 5,
    backgroundColor: Colors.grey3,
    borderRadius: 100,
    borderWidth: 0.75,
    borderColor: Colors.borderColor,
  },
  pendingOrderBlock: {
    paddingHorizontal: 20,
    paddingVertical: 5,
    backgroundColor: Colors.grey3,
    borderRadius: 100,
    borderWidth: 0.75,
    borderColor: Colors.borderColor,
    position: "absolute",
    top: -15,
    left: (Width.width - 200) / 2,
  },
  liquidityBlock: {
    backgroundColor: Colors.grey3,
    paddingVertical: 5,
  },
  btnExternalStyle: {
    borderColor: GlobalScreens.Portfolio.yesBtnBorder,
    borderWidth: 0.2,
    paddingVertical: 8,
    width: 150,
  },
  btnMergeStyle: {
    borderColor: GlobalScreens.Portfolio.noBtnBorder,
    borderWidth: 0.2,
    paddingVertical: 8,
    width: 150,
  },
  btnSellWeb: {
    flex: 1,
    flexBasis: 0,
    flexShrink: 0,
    alignSelf: "flex-end",
    alignContent: "flex-end",
    justifyContent: "flex-end",
    alignItems: "flex-end",
  },
});
